// extracted by mini-css-extract-plugin
module.exports = {"wrapperDateSmall":"interventiondetailtech_wrapperDateSmall_1qP_p"};